<template>
  <div>
    <h1 class="h1">Usuarios</h1>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Nombre Usuario</th>
          <th>Email (cuenta de usuario)</th>
          <th>Activo</th>
          <th>Fecha de Alta</th>
          <th>Rol</th>
          <th cols="2"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td>{{ user.nombreUsuario }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.isEnabled }}</td>
          <td>{{ user.creationDate }}</td>
          <td>{{ user.Rol }}</td>
          <td class="text-right">
            <a v-if="id === null" href="#" @click.prevent="deleteUser(user)"
              >Delete</a
            >
            <b-button
              v-else
              v-b-tooltip.focus
              title="Solicitar Baja"
              v-on:click="deleteRequest(user)"
              size="sm"
              class="m-1"
            >
              <b-icon icon="lock-fill"></b-icon>
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'
// import axios from 'axios'

export default {
  props: {
    id: {
      type: [String, null]
    }
  },
  data () {
    return {
      loading: true,
      users: []
    }
  },
  mounted: function () {
    (async () => {
      await DataAccess.getData('/api/usuarios')
        .then((response) => {
          this.users = response.data
          this.loading = false
        })
        .catch((error) => {
          console.log('ERROR: ', error)
        })
    })()
  },
  methods: {
    makeToast (toaster, variant, title, message, append = false) {
      this.$bvToast.toast(message, {
        toaster: toaster,
        title: title,
        variant: variant,
        solid: true,
        append: append
      })
    },
    deleteUser (post) {
      this.$bvModal
        .msgBoxConfirm('¿Desea borrar el usuario: ' + post.email + ' ?', {
          title: 'Borrado de Usuario - Por favor confirme',
          size: 'lm',
          buttonSize: 'lm',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then((value) => {
          // console.log(value)
          if (value) {
            (async () => {
              await DataAccess.deleteData('/api/usuarios', post.email)
                .then((response) => {
                  this.users = this.users.filter(
                    (e) => e.email !== response.data.email
                  )
                  this.makeToast(
                    'b-toaster-bottom-full',
                    'success',
                    'Eliminación de Registro',
                    'Se ha eliminado con éxito el usuario: ' + post.email
                  )
                })
                .catch((error) => {
                  this.makeToast(
                    'b-toaster-bottom-full',
                    'danger',
                    'Eliminación de Registro',
                    'Errores en el borrado de usuario: ' + post.account
                  )
                  console.log('ERROR: ', error)
                })
            })()
          }
        })
    },
    deleteRequest (item) {
      // console.log(item);
      this.$bvModal
        .msgBoxConfirm(
          '¿Desea solicitud la baja para el usuario : ' + item.email + ' ?',
          {
            title: 'Nueva Solicitud - Por favor confirme',
            size: 'lm',
            buttonSize: 'lm',
            okVariant: 'success',
            okTitle: 'SI',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then((value) => {
          if (value) {
            (async () => {
              await DataAccess.postData('/api/requestUsers', {
                ApplicationUserEmail: this.userAccount,
                isTipoSolicitudALTA: false,
                tallerName: item.name,
                tallerId: item.identifier,
                tallerAddress: item.adress,
                postalCode: item.postalCode,
                population: item.population,
                provinceId: item.provinceId,
                cargaDatos: item.cargaDatos,
                DMSSystemId: item.dmsSystemId
              })
                .then((response) => {
                  this.makeToast(
                    'b-toaster-bottom-full',
                    'success',
                    'Nueva Solicitud',
                    'Se ha enviado con exito la solicitud ' +
                        response.data.tallerName +
                        '. En breve recibira respuesta a la misma.'
                  )
                })
                .catch((error) => {
                  this.makeToast(
                    'b-toaster-bottom-full',
                    'danger',
                    'Nueva Solicitud',
                    'Errores en el envio de la solicitud. Contacte con el administrador del sistema.'
                  )
                  console.log('ERROR: ', error)
                })
            })()
          }
        })
    }
  }
}
</script>
